/**
 * Sider内容组件 包括搜索区域和分组模块
 * created by liyaoh 2021-05-27
 */
import React, { useRef, useState, useEffect } from "react";
import { Cascader, Input, Icon, Menu, Dropdown } from "antd";
import platform from "Pub/js/platform";
const Search = Input.Search;
const { NCButton, NCSelect, NCCascader } = platform.base;
const { NCOption } = NCSelect;
/**
 * Sider查询区域
 */
function SearchArea(props) {
    const {
        contentData,
        json,
        groupData,
        searchValue,
        setSearchValue,
        defaultCascaderValue,
        onAllExpand,
    } = props;
    const searchInputRef = useRef();
    const [showSearch, setShowSearch] = useState(false); //是否显示搜索区域
    const [domainModuleSelect, setDomainModuleSelect] = useState([]); //领域模块下拉
    const isAllShow = groupData.every(item => item.isShow); //全部展开
    const isIndeterminate = !isAllShow && groupData.some(item => item.isShow); //部分展开
    //设置级联下拉默认值
    useEffect(() => {
        setDomainModuleSelect(defaultCascaderValue);
    }, [defaultCascaderValue]);

    //删除关键字
    const handleSearchDel = () => {
        setSearchValue("");
        searchInputRef.current.focus();
    };

    //搜索
    const handleInputSearch = () => {
        props.onSearch(searchValue);
    };
    //搜索框文本改变
    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    //切换搜索状态
    const switchSearch = () => {
        const showSearchVal = !showSearch;
        setShowSearch(showSearchVal);
        if (showSearchVal) {
            setTimeout(() => {
                searchInputRef.current.focus();
            });
            onAllExpand(true);
        } else {
            handleSearchDel();
            props.onCascaderChange(domainModuleSelect);
        }
    };
    //渲染全部展开/收起
    const renderAllShowOrHideMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0" className="all_expand">
                    <NCButton
                        onClick={() => {
                            onAllExpand(true);
                        }}
                        // style={getExpandStyle(!isIndeterminate && isAllShow)}
                        disabled={!isIndeterminate && isAllShow}
                        fieldid="unfold"
                        className={`${(!isIndeterminate && isAllShow) ? 'not-allowed' : 'allowed'}`}
                    >
                        {props.json["DesktopSetting-000036"]}
                        {/* /* 国际化处理： 全部展开*/}
                    </NCButton>
                </Menu.Item>
                <Menu.Item key="1">
                    <NCButton
                        onClick={() => {
                            onAllExpand(false);
                        }}
                        // style={getExpandStyle(!isIndeterminate && !isAllShow)}
                        className={`${(!isIndeterminate && isAllShow) ? 'allowed' : 'not-allowed'}`}
                        disabled={!isIndeterminate && !isAllShow}
                        fieldid="fold"
                    >
                        {props.json["DesktopSetting-000037"]}
                        {/* /* 国际化处理： 全部收起*/}
                    </NCButton>
                </Menu.Item>
            </Menu>
        );
    };

    //切换下拉
    const handleCascaderChange = (value, selectedOptions) => {
        setDomainModuleSelect(value);
        props.onCascaderChange(value, selectedOptions);
    };
    const renderSearchArea = () => {
        //搜索结果无展开，收起
        const suffixIcon = (
            <span className="fixed-search-icon-group">
                {searchValue.length > 0 && (
                    <i className="iconfont icon-qingkong" onClick={handleSearchDel} />
                )}
                <i
                    className="iconfont icon-chaxun left-icon-sousuo"
                    onClick={handleInputSearch}
                />
                <span className="switch-search-cancel" onClick={switchSearch}>
                    {json["DesktopSetting-000009"]}
                    {/* /* 国际化处理： 取消*/}
                </span>
            </span>
        );
        let searchResult = "";
        contentData &&
            contentData.map((val) => {
                searchResult = val.label;
            });
        if (showSearch) {
            return (
                <div className="sider-search fixed-search-input">
                    <div className="select-area search" fieldid="picker">
                        <Search
                            ref={searchInputRef}
                            placeholder={
                                json["DesktopSetting-000031"]
                            } /* 国际化处理： 请输入应用名称，回车搜索*/
                            style={{ width: "100%" }}
                            onChange={handleInputChange}
                            onSearch={handleInputSearch}
                            value={searchValue}
                            suffix={suffixIcon}
                            className="fieldid_picker_select"
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="sider-search">
                    <div className="select-area" fieldid="picker">
                        {renderCascader()}
                        <div className="switch-search" onClick={switchSearch}>
                            <i
                                title={
                                    json["DesktopSetting-000033"]
                                } /* 国际化处理： 切换至名称搜索*/
                                className="iconfont icon-chaxun left-icon-sousuo"
                            />
                        </div>
                    </div>
                    {searchResult === json["DesktopSetting-000034"] /* 国际化处理： 搜索结果*/ ? (
                        ""
                    ) : (
                        <Dropdown
                            trigger={["hover"]}
                            placement="bottomCenter"
                            overlay={renderAllShowOrHideMenu()}
                            overlayClassName="fieldid_opr_menu"
                        // visible={true}
                        >
                            <i className={`iconfont fold-icon ${isAllShow ? 'icon-quanbuzhankai' : 'icon-quanbushouqi'} `} />
                        </Dropdown>
                    )}
                </div>
            );
        }
    };

    //渲染级联下拉
    const renderCascader = () => {
        return (
            <Cascader
                className="search-cascader"
                allowClear={false}
                defaultValue={domainModuleSelect}
                value={domainModuleSelect}
                options={props.cascaderOptions}
                onChange={handleCascaderChange}
                placeholder={json["DesktopSetting-000032"]} /* 国际化处理： 请选择领域-模块*/
                expandTrigger="hover"
                popupClassName="desk-setting-cascader-popup fieldid_picker_select"
            />
        );
    };

    return renderSearchArea();
}
export default SearchArea;
